import React, { Component } from "react";
import { Row, Col, Alert, CardBody, Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { BeatLoader } from "react-spinners"
import { Link } from 'react-router-dom'
import { AssessSelectorBar } from "../Assessment"
import ReactModal from "react-modal";
import ReactPlayer from "react-player";
import has from "mout/object/has";
import { db } from "../../config/firebaseconfig";
import {
  findNoCompletionsAlertNeeded,
  findPrintPath,
  findFirstIncompleteSubtest
} from "../../helpers/assessment/assessmentDashboard";
import { NoDataAlert, CardLoading, TopCard, SubtestCards } from "./AssessDash";
import isLicenseExpired from '../../helpers/users/licenses/isLicenseExpired'
// Parent view component for '/assessment/dashboard' route
class AssessmentDashboard extends Component {
  constructor() {
    super();

    this.state = {
      afterTestPopUp: false
    };
  }

  componentDidMount() {
    // Determine student comes first time on dashboard
    if (this.props.user !== null && this.props.userAssessment) {
      const user = this.props.user || this.state.user;
      let userAssessmentList = {};
      if (this.props.userAssessment.scoring !== null) {
        userAssessmentList =
          this.props.userAssessment.scoring &&
          this.props.userAssessment.scoring.bySubtest;
      }

      let completedTest = 0;
      Object.keys(userAssessmentList).forEach(function (key) {
        if (userAssessmentList[key].complete === true) {
          completedTest = completedTest + 1;
        }
      });

      if (this.props.afterTest === false && completedTest === 1) {
        setTimeout(() => {
          db.collection('userVideoTurorial').doc(user.id).set({ is_first_video_show: true, is_afterTest_video_show: true })
        }, 1000);

        this.setState({ afterTestPopUp: true });
      } else {
        this.setState({ afterTestPopUp: false });
      }
    }
  }

  render() {
    const {
      userAssessment,
      userAssessmentCompare,
      user,
      isCompare,
      selectedGroupUA,
      selectedGroupUACompare,
      compareAssismentId,
      groupUAComapre,
      selectedStudent,
      nodes,
      assessmentId,
      groupUA,
      groupUAs,
      groupData,
      isFetchingGroupUAs,
      isInitializing,
      isFetchingNodes,
      GUAFilter,
      selectStudent,
      assessmentInitializingError,
      manageEducatorsError,
      selectGroupUA,
      currentAssessmentId,
      isAssessmentInitializing,
      is_close,
      previousTest,
      year,
      updatingGUA,
      updatePasswordModal,
      modalIsOpen,
      closeUpdatePasswordModal,
      compareGuaYear
    } = this.props;

    let topResume = false;
    let topComplete = false;
    let gUA;
    let gUACompare;
    //if(this.props.schools)
    const firstIncompleteSubtest = findFirstIncompleteSubtest(userAssessment);
    if (Object.keys(firstIncompleteSubtest).length > 0) {
      topResume = Object.keys(userAssessment.activity).length > 0;
    }

    // If we are looking at a group's data, or if we are looking at an
    // individual student's data and their test is complete, then display
    // top card as complete. Otherwise, use incomplete format.
    if (userAssessment) {
      topComplete = userAssessment.scoring.byTest.complete === true;
    } else if (selectedGroupUA) {
      topComplete = true;
    }

    // Determine title for overall assessment
    // if (
    //   has(user, `role`) &&
    //   user.role !== "Student" &&
    //   selectedGroupUA &&
    //   groupUAs &&
    //   groupUAs[selectedGroupUA]
    // ) {
    //   if (groupUAs[selectedGroupUA][year]) {

    //     gUA = groupUA
    //     gUACompare = groupUAComapre 
    //     console.log(gUACompare)
    //   }
    // }

    if (
      user.role !== "Student" &&
      selectedGroupUA &&
      groupUAs &&
      groupUAs[selectedGroupUA]
    ) {
      gUA = groupUAs[selectedGroupUA];

      if (has(gUA, `${year}`)) {
        gUA = groupUAs[selectedGroupUA][year][assessmentId];
        gUACompare = groupUAComapre
      }
    }


    // Verifies that we have pulled all group records
    const groupDataCheck =
      !!groupData.districts &&
      !!groupData.schools &&
      !!groupData.schools &&
      !!groupData.educators &&
      !!groupData.students;


    let licenseMessage = false;
    // let swapArrayStudent 
    // if(this.props.isSwap && (selectStudent || user.role === "Student") && userAssessment ){
    //   console.log("abc1234")
    //  swapArrayStudent = this.userAssessment;
    //   this.userAssessment = this.userAssessmentCompare;
    //   this.userAssessmentCompare = swapArrayStudent;

    // }
    // else{

    // }

    // Creates a summary data object based on role and what we're
    // looking at
    let sumData1 = {};
    if (userAssessment && user.role === "Student") {
      sumData1.userAssessmentId = userAssessment.userAssessmentId;
      sumData1.scoring = userAssessment.scoring;
      sumData1.subtests = userAssessment.assessmentSubtests;
    } else if (userAssessment && selectedStudent) {
      sumData1.userAssessmentId = userAssessment.userAssessmentId;
      sumData1.scoring = userAssessment.scoring;
      sumData1.subtests = userAssessment.assessmentSubtests;
    } else if (gUA) {
      sumData1.groupUAId = selectedGroupUA;
      sumData1.scoring = gUA.scoring;
      sumData1.subtests = gUA.assessmentSubtests;
    }

    let sumDataCompare1 = {};
    if (userAssessment && user.role === "Student") {
      sumDataCompare1.userAssessmentId = userAssessmentCompare && userAssessmentCompare.userAssessmentId;
      sumDataCompare1.scoring = userAssessmentCompare && userAssessmentCompare.scoring;
      sumDataCompare1.subtests = userAssessmentCompare && userAssessmentCompare.assessmentSubtests;
    } else if (userAssessment && selectedStudent) {
      sumDataCompare1.userAssessmentId = userAssessmentCompare && userAssessmentCompare.userAssessmentId;
      sumDataCompare1.scoring = userAssessmentCompare && userAssessmentCompare.scoring;
      sumDataCompare1.subtests = userAssessmentCompare && userAssessmentCompare.assessmentSubtests;
    } else if (gUACompare) {
      sumDataCompare1.groupUAId = selectedGroupUACompare;
      sumDataCompare1.scoring = gUACompare.scoring;
      sumDataCompare1.subtests = gUACompare.assessmentSubtests;
    }
    
    let sumData = {};
   let sumDataCompare ={};
    let swapArray
    if(this.props.isSwap ){
      sumData = sumDataCompare1;
      sumDataCompare =sumData1;
      
    }else{
      sumData = sumData1;
      sumDataCompare =sumDataCompare1;
    }
   
   

    
    //console.log("scoringCompare",sumDataCompare.scoring)

    const notInitializing =
      !isFetchingGroupUAs && !isInitializing && !isFetchingNodes && groupUAs;

    // needAlert controls display of the 'No Data' alerts
    const needAlert = findNoCompletionsAlertNeeded(
      user.role,
      sumData.scoring,
      notInitializing,
      selectedStudent,
      userAssessment,
      groupUA
    );

    // determine path for exporting to pdf

    const printPath = findPrintPath(
      year,
      userAssessment,
      user.role,
      assessmentId,
      selectedStudent,
      sumData
    );

    // checks to see that the groupUA is not null. The groupUA contains
    // all of the test report information on a group of students.
    const nullGUACheck = !(
      user.role !== "Student" &&
      groupDataCheck &&
      !groupUA
    );

    var msg = "This student has not taken this test, yet.";
    if (!(has(this.props, `groupData.${selectedGroupUA}`) && assessmentId)) {
      if (typeof groupData !== "undefined") {
        let is_found = false;
        if (
          groupData["schools"] != null &&
          groupData["schools"][selectedGroupUA]
        ) {
          msg = "No students in this school have taken this test, yet.";
        }

        if (
          groupData["educators"] != null &&
          groupData["educators"][selectedGroupUA]
        ) {
          if (user.role === "Teacher") {
            msg =
              "No students assigned to your classes have taken this test, yet.";
          } else {
            msg =
              "No students assigned to this teacher's classes have taken this test, yet.";
          }
        }

        if (
          groupData["classes"] != null &&
          groupData["classes"][selectedGroupUA]
        ) {
          msg = "No students assigned to this class have taken this test, yet.";
        }
        if (
          groupData["students"] != null &&
          groupData["students"][selectedGroupUA]
        ) {
          msg = "No students assigned to this class have taken this test, yet.";
        }
      }
    }
    const alertBackgroundColor = {
      backgroundColor: "#DA5965",
      color: "#FFF"
    };
    const customStyles = {
      content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        color: "#62b6e8",
        backgroundColor: "rgb(216, 216, 216)"
      }
    };
    const spanStyle = {
      color: "#6e6e6e",
      float: "right",
      cursor: "pointer"
    };
    const divPaddingStyle = {
      paddingTop: "14px"
    };
    const selectHeaderStye = {
      display: "flex",
      flexWrap: "wrap",
      marginTop: "-21px"
    };
    // figure out what tutorialURL to use
    const tutorialUrls = {
      studentLaunch: "https://masteryprep.wistia.com/medias/iv8usbsdpw",
      studentAfterFirstTest: "https://masteryprep.wistia.com/medias/2m6gjy4hqd",
      teacherLaunch: "https://masteryprep.wistia.com/medias/9j417ce1u6"
    };
    let tutorialUrl;
    if (user.role !== "Student") {
      tutorialUrl = tutorialUrls.teacherLaunch;
    } else if (
      this.state.afterTestPopUp === true &&
      this.props.modalIsOpen === true
    ) {
      tutorialUrl = tutorialUrls.studentAfterFirstTest;
    } else {
      tutorialUrl = tutorialUrls.studentLaunch;
    }
    return (
      <div>
        <div style={selectHeaderStye}>
          {user.role !== "Student" && groupDataCheck && (
            <AssessSelectorBar
              assessmentId={assessmentId}
              groupData={groupData}
              groupUAs={groupUAs}
              GUAFilter={GUAFilter}
              isAssessmentInitializing={isAssessmentInitializing}
              role={user.role}
              selectedGroupUA={selectedGroupUA}
              selectedStudent={selectedStudent}
              selectGroupUA={selectGroupUA}
              selectStudent={selectStudent}
              updatingGUA={updatingGUA}
              user={user}
              userAssessment={userAssessment}
              isAssessmentInitializing={isAssessmentInitializing}
              year={year}
            />
          )}
        </div>
        <Row>
          {!!(Object.keys(assessmentInitializingError).length || Object.keys(manageEducatorsError).length) && (
            <Col><Alert color="danger">
              Error loading. Please check your internet connection and try
              again.
            </Alert>
            </Col>
          )}
          {userAssessment && (isLicenseExpired(user.role, userAssessment.assessmentSetId, this.props.userLicenses)) && (
            <Col><Alert color="danger">
              Your license has expired.
            </Alert>
            </Col>
          )}
          <div>
            <Modal className={'modal-changepass-center'} isOpen={updatePasswordModal} centered backdrop>
              <ModalHeader>Change Your Password</ModalHeader>
              <ModalBody>
                For security reasons, we strongly recommend that you update your password and email address information.
          </ModalBody>
              <ModalFooter>
                <Link to='/profile' className="change-password-btn"><Button color="primary">Change Your Password</Button></Link>{' '}
            <Button color="secondary" onClick={closeUpdatePasswordModal}>Cancel</Button>
              </ModalFooter>
            </Modal>
            <ReactModal
              isOpen={
                (this.props.modalIsOpen === false && this.props.is_close && this.props.init) ||
                (this.state.afterTestPopUp === true && this.props.is_close && this.props.init)
              }
              style={customStyles}
              shouldCloseOnEsc={true}
              onRequestClose={this.props.closeModal}
              contentLabel="Tutorial"
            >
              <ReactPlayer url={tutorialUrl} controls={true} />
              <div style={divPaddingStyle}>
                <span onClick={this.props.closeModal} style={spanStyle}>
                  Close
                </span>
              </div>
            </ReactModal>
          </div>

          {user.role !== "Student" && !groupDataCheck && !notInitializing && (
            <CardLoading />
          )}
          {nullGUACheck && sumData.subtests && (
            <TopCard
              sm="12"
              md="12"
              lg="12"
              xl="12"
              sub={false}
              subtest={firstIncompleteSubtest}
              resume={topResume}
              userAssessmentId={
                sumData.userAssessmentId ? sumData.userAssessmentId : ""
              }
              groupUAId={sumData.groupUAId ? sumData.groupUAId : ""}
              scoring={sumData.scoring}
              isCompare = {isCompare}
              scoringCompare ={sumDataCompare.scoring}
              subtests={sumData.subtests}
              topComplete={topComplete}
              assessmentId={assessmentId}
              selectedGroupUA={selectedGroupUA}
              selectedStudent={selectedStudent}
              isStudent={user.role === "Student"}
              needAlert={needAlert}
              groupUA={groupUA}
              groupUAs={groupUAs}
              userAssessment={userAssessment}
              user={user}
              printPath={printPath}
              notInitializing={notInitializing}
              currentAssessmentId = {currentAssessmentId}
              test1 = {this.props.test1}
              test2 = {this.props.test2}
              isSwap = {this.props.isSwap}
              year = {year}
            />
          )}
          {/* <NoDataAlert
            role={user.role}
            scoring={sumData.scoring}
            notInitializing={notInitializing}
            selectedStudent={selectedStudent}
            userAssessment={userAssessment}
            groupUA={groupUA}
          /> */}
          {nullGUACheck && (
            <SubtestCards
              scoring = {sumData.scoring} 
              scoringCompare = {sumDataCompare.scoring}
              userAssessment={userAssessment}
              selectedStudent={selectedStudent}
              selectedGroupUA={selectedGroupUA}
              groupUAs={groupUAs}
              nodes={nodes}
              assessmentId={assessmentId}
              groupUA={groupUA}
              user={user}
              isAssessmentInitializing={isAssessmentInitializing}
              previousTest={previousTest}
              year={year}
              isCompare = {isCompare} 
              compareAssismentId = {compareAssismentId} 
              currentAssessmentId = {currentAssessmentId}
              test1 = {this.props.test1}
              test2 = {this.props.test2}
              isSwap = {this.props.isSwap}
              compareGuaYear={compareGuaYear}
              isLicenseExpired={isLicenseExpired}
            />
          )}
          {!notInitializing && (
            <BeatLoader loading={!groupUAs && !nullGUACheck} />
          )}

          {!nullGUACheck && groupUAs && (
            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <Alert color="danger" style={alertBackgroundColor}>
                {msg}
              </Alert>
            </div>
          )}
        </Row>
      </div>
    );
  }
}

export default AssessmentDashboard;



// WEBPACK FOOTER //
// ./src/components/Assessment/AssessmentDashboard.js